import { Check } from "lucide-react";
import { Logo } from "@/components/layout/Logo";

const LOGIN_BG =
  "https://images.unsplash.com/photo-1585854467604-cf2080ccef31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxsaWdodCUyMGJsdWUlMjBhYnN0cmFjdCUyMGZsdWlkfGVufDB8fHx8MTc4MjgzNTcyNHww&ixlib=rb-4.1.0&q=85";

const HIGHLIGHTS = [
  "One workspace for orders, inbound, inventory and returns.",
  "Built for 3PLs, VA agencies and modern e-commerce brands.",
  "Fast, permission-ready and effortless to scale.",
];

export function AuthLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-background">
      <div className="flex flex-1 flex-col justify-center px-6 py-12 sm:px-12 lg:px-20">
        <div className="mx-auto w-full max-w-sm animate-fade-in-up">
          <Logo className="mb-10" />
          {children}
          <p className="mt-12 text-xs text-muted-foreground">
            © 2026 FulfillFlow. All rights reserved.
          </p>
        </div>
      </div>

      <div className="relative hidden w-[46%] overflow-hidden lg:block">
        <img
          src={LOGIN_BG}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/75" />
        <div className="relative flex h-full flex-col justify-end p-14 text-white">
          <h2 className="max-w-md text-3xl font-bold leading-tight tracking-tight">
            The operating system for modern fulfillment.
          </h2>
          <ul className="mt-8 space-y-4">
            {HIGHLIGHTS.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/20">
                  <Check className="h-3 w-3" />
                </span>
                <span className="text-sm text-white/90">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
